import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/SecurityConfiguration";

export const getAllSafeMake = async () => {
  return axios.get(`${api_base_url}/GetSafeMake`).then((res) => {
    return res;
  });
};

export const addSafeMake = async (newSafeMake) => {
  const { data } = await axios.post(`${api_base_url}/AddSafeMake`, newSafeMake);
  return data;
};

export const updateSafeMake = async (updateSafeMake) => {
  const { data } = await axios.put(
    `${api_base_url}/UpdateSafeMake`,
    updateSafeMake
  );
  return data;
};

export const deleteSafeMake = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateSafeMake`, {
    data: ids,
  });
  return data;
};
